// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__15se3","focus":"styles_focus__9IzMA","hoverHint":"styles_hoverHint__3-2eB"};